// extracted by mini-css-extract-plugin
module.exports = {"infoItem":"TagsInformation_infoItem__K2UMQ","chips":"TagsInformation_chips__3dZUL"};